import { CIUDAD, CLIENTE, USUARIO_CLIENTE, logistica_CONTENIDO, logistica_GUIA_PROFORMA, logistica_MANIFIESTO_PROFORMA_DETALLE, logistica_RANGO_GUIA, logistica_RANGO_SEGURO } from "@pcgerente-node/pcg-comun/dist/DTOs";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { logistica_GUIA_PROFORMALocal } from "../../components/Entidades/logistica_GUIA_PROFORMA";
import { structureInfoState } from "../helpersRedux";

const initialState={
  ciudadesCrear: new structureInfoState([] as CIUDAD[]), //Nos trae todas las ciudades (CIUDAD)
  rangoGuia: new structureInfoState(new logistica_RANGO_GUIA), // Es el rango Guia (RANGO_GUIA)
  remitente: new structureInfoState([] as USUARIO_CLIENTE[]), //nos trae los remitentes del usuario (USUAIO_CLIENTE)
  destinatario: new structureInfoState(new CLIENTE), // nos trae la información del destinatario (CLIENTE)
  ContenidoGuia: new structureInfoState([] as logistica_CONTENIDO[]), // nos trae los productos del remitente (GUIA_DETALLE? en este proyecto se usa DetalleDTO)
  ciudadesOrigen: new structureInfoState([] as CIUDAD[]), // nos trae las ciudades de origen del remitente (CIUDAD)
  ciudadesDestino: new structureInfoState([] as CIUDAD[]), // nos trae las ciudades de origen del remitente (CIUDAD)
  guiaPrevisualizar: new structureInfoState(new logistica_GUIA_PROFORMALocal()), // nos guarda la guia que hemos creado para poder editar la información, imprimirla, o mandarla a guardar
  imprimirManifiestosProforma: new structureInfoState([] as logistica_MANIFIESTO_PROFORMA_DETALLE[]), // nos guarda la guia que hemos creado para poder editar la información, imprimirla, o mandarla a guardar
  guiasProformaDB: new structureInfoState([] as logistica_GUIA_PROFORMA[]), // nos trae todas las guias proforma vinculadas al usuario (GUIA) 
  guiaProformaImprimir: new structureInfoState(new logistica_GUIA_PROFORMA),
  rangosSegurosPorDefecto: new structureInfoState([] as logistica_RANGO_SEGURO[])
}


export const guiaSlice = createSlice({
  name: "guia",
  initialState,
  reducers: {
    setCiudadesCrear: (state, action: PayloadAction<structureInfoState<CIUDAD[]>>) =>{
        state.ciudadesCrear = action.payload
    },

    setRangoGuia: (state, action: PayloadAction<structureInfoState<logistica_RANGO_GUIA>>) =>{
      state.rangoGuia = action.payload
    },

    
    setRemitente: (state, action: PayloadAction<structureInfoState<USUARIO_CLIENTE[]>>) =>{
      state.remitente = action.payload
    },

    setDestinatario: (state, action: PayloadAction<structureInfoState<CLIENTE>>) =>{
      state.destinatario = action.payload
    },

    setContenidoGuia: (state, action: PayloadAction<structureInfoState<logistica_CONTENIDO[]>>) =>{
      state.ContenidoGuia= action.payload
    },

    setCiudadesOrigen: (state, action: PayloadAction<structureInfoState<CIUDAD[]>>) =>{
      state.ciudadesOrigen = action.payload
    },

    setCiudadesDestino: (state, action: PayloadAction<structureInfoState<CIUDAD[]>>) =>{
      state.ciudadesDestino = action.payload
    },

    setimprimirManifiestoProforma: (state, action: PayloadAction<structureInfoState<logistica_MANIFIESTO_PROFORMA_DETALLE[]>>) =>{
      state.imprimirManifiestosProforma = action.payload
    },
    
    setGuiaPrevisualizar:(state, action: PayloadAction<structureInfoState<logistica_GUIA_PROFORMALocal>>) =>{
      state.guiaPrevisualizar = action.payload
    },

    setGuiaProformaImprimir:(state, action: PayloadAction<structureInfoState<logistica_GUIA_PROFORMA>>) =>{
      state.guiaProformaImprimir = action.payload 
    },

    setGuiasProformaDB:(state, action: PayloadAction<structureInfoState<logistica_GUIA_PROFORMA[]>>) =>{
      state.guiasProformaDB = action.payload
    },
    
    setRangosSegurosPorDefecto:(state, action: PayloadAction<structureInfoState<logistica_RANGO_SEGURO[]>>) =>{
      state.rangosSegurosPorDefecto = action.payload
    }
}
});


export const {
  setCiudadesCrear, 
  setRangoGuia,
  setRemitente,
  setDestinatario,
  setCiudadesOrigen,
  setGuiaPrevisualizar,
  setGuiasProformaDB,
  setGuiaProformaImprimir,
  setCiudadesDestino,
  setimprimirManifiestoProforma,
  setContenidoGuia  ,
  setRangosSegurosPorDefecto
} =guiaSlice.actions

export default guiaSlice.reducer